<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="title"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
  [nzOkLoading]="uploading"
  [nzWidth]="800"
  [nzBodyStyle]="{ height: '500px', overflow: 'hidden' }"
  [testId]="'avatar-upload-modal'"
>
  <ng-container *nzModalContent>
    <div class="avatar-upload-container" [testId]="'avatar-upload-container'">
      <input
        #fileInput
        type="file"
        (change)="fileChangeEvent($event)"
        accept="image/png,image/jpeg,image/gif,image/jpg"
        style="display: none"
        [testId]="'avatar-file-input'"
      />

      <div class="upload-area" *ngIf="!imageChangedEvent" [testId]="'avatar-upload-area'">
        <div class="upload-button-area" [testId]="'avatar-upload-button-area'">
          <div class="upload-icon" [testId]="'avatar-upload-icon'">
            <nz-icon nzType="cloud-upload" nzTheme="outline" [testId]="'avatar-cloud-upload-icon'" />
          </div>
          <button nz-button nzType="primary" (click)="fileInput.click()" [testId]="'avatar-select-file-button'">
            <nz-icon nzType="upload" [testId]="'avatar-upload-button-icon'" />{{ 'avatar.upload.select-file' | i18n }}
          </button>
          <p class="upload-hint" [testId]="'avatar-upload-hint'">{{ 'avatar.upload.file-format-hint' | i18n }}</p>
        </div>
      </div>

      <div class="cropper-container" *ngIf="imageChangedEvent" [testId]="'avatar-cropper-container'">
        <div class="cropper-wrapper" [testId]="'avatar-cropper-wrapper'">
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="aspectRatio"
            [resizeToWidth]="resizeToWidth"
            [containWithinAspectRatio]="true"
            [canvasRotation]="0"
            format="png"
            (imageCropped)="imageCropped($event)"
            (loadImageFailed)="loadImageFailed()"
            [testId]="'avatar-image-cropper'"
          />
        </div>

        <div class="cropper-actions" [testId]="'avatar-cropper-actions'">
          <button nz-button nzType="default" (click)="resetAndSelectImage()" [testId]="'avatar-reselect-button'">
            <nz-icon nzType="reload" [testId]="'avatar-reload-icon'" />{{ 'avatar.upload.reselect' | i18n }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
